import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "CircleClose"
});
const _hoisted_1 = {
  class: "icon",
  width: "200px",
  height: "200.00px",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M467.008 512l-91.008-90.016q-8.992-10.016-8.992-23.008t9.504-22.496 22.496-9.504 23.008 8.992l90.016 91.008 90.016-91.008q14.016-12.992 31.488-8t22.496 22.496-8 31.488l-91.008 90.016 91.008 90.016q12.992 14.016 8 31.488t-22.496 22.496-31.488-8l-90.016-91.008-90.016 91.008q-10.016 8.992-23.008 8.992t-22.496-9.504-9.504-22.496 8.992-23.008zM512 896q163.008-4 271.488-112.512T896 512q-4-163.008-112.512-271.488T512 128q-163.008 4-271.488 112.512T128 512q4 163.008 112.512 271.488T512 896z m0 64q-190.016-4.992-316.512-131.488T64 512q4.992-190.016 131.488-316.512T512 64q190.016 4.992 316.512 131.488T960 512q-4.992 190.016-131.488 316.512T512 960z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var circleClose = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "E:\\gitlab\\sgui-plus-icon\\packages\\vue\\src\\circle-close.vue"]]);

export { circleClose as default };
